import React, { useContext } from 'react';
import { Prices } from "./components/Prices";
import { ProductContext } from "../../../../pages/ProductStencil";

export const SingleSKU = ({ enabled, outsideContext = null }) => {
  const productData = useContext(ProductContext);
  const { activeProductIndex } = productData;
  let packaging = productData.Packaging[activeProductIndex];


  if (outsideContext) {
    if (outsideContext.Packagings?.length) {
      packaging = outsideContext.Packagings[0];
    } else {
      return null;
    }
  }

  if (packaging.IsObsolete || !packaging.HasPrice) { return null; }

  return (
    <div className={'single-sku'}>
      {enabled && <Prices data={packaging} onlySingle={!!outsideContext}/>}
    </div>
  );
}
